export const exportToExcel = (datos, nombreArchivo) => {
  if (!datos || datos.length === 0) {
    alert('No hay datos para exportar');
    return;
  }

  const headers = [
    'Fecha',
    'Apellido',
    'Nombre',
    'DNI',
    'Práctica',
    'Obra Social',
    'Estado',
    'Importe'
  ];

  let csvContent = headers.join('\t') + '\n';

  datos.forEach(item => {
    const row = [
      item.f_Estudio || item.fechaEstudio || '',
      item.apellido || '',
      item.nombre || '',
      item.dni || '',
      item.practica || '',
      item.obraSocial || '',
      item.estado || item.estadoTurno || '',
      parseFloat(item.importe || item.importeTecnico || 0).toFixed(2)
    ];
    csvContent += row.join('\t') + '\n';
  });

  const blob = new Blob(['\ufeff' + csvContent], { 
    type: 'application/vnd.ms-excel;charset=utf-8;' 
  });

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${nombreArchivo}.xls`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
